import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { useAuthStore } from '@/stores/auth'
import { useAiGuestAccessStore } from '@/features/ai-doc/guest-access'

const AI_CONVERSATION_QUERY_KEYS = new Set(['conversations', 'conversation', 'messages'])

export function AiConversationAuthBoundary() {
  const isLoggingOut = useAuthStore((state) => state.isLoggingOut)
  const finishLogout = useAuthStore((state) => state.finishLogout)
  const clearGuestAccess = useAiGuestAccessStore((state) => state.clearAccess)
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!isLoggingOut) return

    clearGuestAccess()
    queryClient.removeQueries({
      predicate: (query) =>
        query.queryKey[0] === 'ai-doc' &&
        typeof query.queryKey[1] === 'string' &&
        AI_CONVERSATION_QUERY_KEYS.has(query.queryKey[1]),
    })
    finishLogout()
  }, [clearGuestAccess, finishLogout, isLoggingOut, queryClient])

  return null
}
